export default "__VITE_ASSET__DGC3AQ9x__"